/**
 * Pure pieces of Transformer wiring from `upp-floor-plan` (testable without the Angular host).
 */

export function floorPlanResolveTransformEndAnchor(params: {
  multiUniform: boolean;
  gestureAnchor: string | null;
  transformer: { getActiveAnchor?: () => string | null | undefined } | null | undefined;
}): string | null {
  if (params.multiUniform && params.gestureAnchor != null) {
    return params.gestureAnchor;
  }
  const tr = params.transformer;
  if (tr != null && typeof tr.getActiveAnchor === 'function') {
    const a = tr.getActiveAnchor();
    return a == null ? null : a;
  }
  return null;
}

export function floorPlanTransformCommitRotationSnapshot(
  multiUniform: boolean,
  snapshot: readonly number[] | null,
  transformableCount: number,
): readonly number[] | undefined {
  if (multiUniform && snapshot != null && snapshot.length === transformableCount) {
    return snapshot;
  }
  return undefined;
}

export function floorPlanTransformerBoundBoxWithMinSize(minPx: number) {
  return (oldBox: { width: number; height: number }, newBox: { width: number; height: number }) => {
    if (newBox.width < minPx || newBox.height < minPx) {
      return oldBox;
    }
    return newBox;
  };
}

export function floorPlanTransformerEventNamespace(transformer: {
  _getEventNamespace?: () => string;
}): string {
  return typeof transformer._getEventNamespace === 'function' ? transformer._getEventNamespace() : '';
}
